<template>
    <div>
        <div class="table-responsive"
             data-toggle="lists"
             data-lists-sort-by="js-lists-values-date"
             data-lists-sort-desc="true"
             data-lists-values='["js-lists-values-name", "js-lists-values-company", "js-lists-values-phone", "js-lists-values-date"]'>

            <table class="table mb-0 thead-border-top-0 table-nowrap">
                <thead>
                <tr>
                    <th>Nome</th>
                    <th class="text-center">Data Inscrição</th>
                    <th class="text-center">Progresso</th>
                    <th class="text-center">Atividades Pendentes</th>
                    <th class="text-center">Sessões</th>
                    <th class="text-center">Ações</th>
                </tr>
                </thead>
                <tbody class="list" id="contacts">
                <tr v-for="menteeMentoring in menteeMentorings" :key="menteeMentoring.id">
                    <td>
                        <router-link :to="`/mentorias/detalhes/${mentoring}/mentorando/${menteeMentoring.mentee.id}`">
                            <div class="media flex-nowrap align-items-center" style="white-space: nowrap;">
                                <div class="avatar avatar-sm mr-8pt">
                                    <img class="avatar-title rounded-circle"
                                         :src="menteeMentoring.mentee.photo_url" alt="">
                                </div>
                                <div class="media-body">
                                    <div class="d-flex flex-column">
                                        <p class="mb-0">
                                            <strong class="js-lists-values-name">{{ menteeMentoring.mentee.name }}</strong>
                                        </p>
                                        <small class="js-lists-values-email text-50">{{ menteeMentoring.mentee.email }}</small>
                                    </div>
                                </div>
                            </div>
                        </router-link>
                    </td>
                    <td class="text-center">
                        <small class="js-lists-values-date text-50">{{ convertDateText(menteeMentoring.created_at) }}</small>
                    </td>
                    <td class="text-center">
                        <small class="js-lists-values-date text-50">{{ menteeMentoring.progress.replace('.', ',') }}%</small>
                    </td>
                    <td class="text-center">
                        <small class="js-lists-values-date text-50">{{ menteeMentoring.pendency }}</small>
                    </td>
                    <td class="text-center" data-testid="enrollment-sessions">
                        <small v-if="menteeMentoring.sessions_quota != null">
                            {{ menteeMentoring.sessions_used || 0 }}/{{ menteeMentoring.sessions_quota }}
                        </small>
                        <small v-else-if="menteeMentoring.scheduling_finished_at" class="text-muted">Finalizada</small>
                        <small v-else-if="menteeMentoring.scheduling_blocked_at" class="text-warning">Bloqueada</small>
                        <small v-else class="text-muted">—</small>
                    </td>
                    <td class="text-center">
                        <div class="btn-group btn-group-sm" v-if="showSessionActions(menteeMentoring)">
                            <button
                                type="button"
                                class="btn btn-outline-primary"
                                data-testid="enrollment-grant-credit"
                                title="Liberar +1 crédito"
                                :disabled="actingId === menteeMentoring.id"
                                @click="grantCredit(menteeMentoring)"
                            >
                                +1
                            </button>
                            <button
                                v-if="!menteeMentoring.scheduling_blocked_at"
                                type="button"
                                class="btn btn-outline-warning"
                                data-testid="enrollment-block"
                                title="Bloquear agendamentos"
                                :disabled="actingId === menteeMentoring.id"
                                @click="blockScheduling(menteeMentoring)"
                            >
                                Bloquear
                            </button>
                            <button
                                v-else
                                type="button"
                                class="btn btn-outline-secondary"
                                data-testid="enrollment-unblock"
                                title="Desbloquear"
                                :disabled="actingId === menteeMentoring.id"
                                @click="unblockScheduling(menteeMentoring)"
                            >
                                Desbloquear
                            </button>
                            <button
                                v-if="!menteeMentoring.scheduling_finished_at"
                                type="button"
                                class="btn btn-outline-danger"
                                data-testid="enrollment-finish"
                                title="Finalizar agenda"
                                :disabled="actingId === menteeMentoring.id"
                                @click="finishScheduling(menteeMentoring)"
                            >
                                Finalizar
                            </button>
                        </div>
                        <small v-else class="text-muted">—</small>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>

        <div class="card-footer p-8pt">
            <ul class="pagination justify-content-start pagination-xsm m-0">
                <li class="page-item" :class="{disabled: menteePage == 1}"
                    @click="getMentees(menteePage - 1)">
                    <a class="page-link" href="#" aria-label="Previous">
                        <span aria-hidden="true" class="material-icons">chevron_left</span>
                        <span>Anterior</span>
                    </a>
                </li>
                <li v-for="n in menteePages" :key="n" class="page-item">
                    <a @click="getMentees(n)" class="page-link"
                       :class="{currentPage: n == menteePage}"
                       href="#"
                       aria-label="Page 1">
                        <span>{{ n }}</span>
                    </a>
                </li>
                <li class="page-item" :class="{disabled: menteePage == menteePages}"
                    @click="getMentees(menteePage + 1)">
                    <a class="page-link" href="#" aria-label="Next">
                        <span>Próximo</span>
                        <span aria-hidden="true" class="material-icons">chevron_right</span>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>

import {endLoading, startLoading} from "@/components/composables/spinners";
import http from "@/http";
import {convertDateText} from "../../../components/composables/masks";

export default {
    data() {
        return {
            menteeMentorings: {},
            menteePages: '',
            menteePage: '',
            mentoring: this.$route.params.id,
            actingId: null,
        }
    },
    methods: {
        convertDateText,
        showSessionActions(row) {
            return row.status === 'confirmed' || row.status === 'pending';
        },
        grantCredit(row) {
            this.actingId = row.id;
            http.post(`mentor/enrollments/${row.id}/grant-session-credits`, { amount: 1 })
                .then((response) => {
                    row.sessions_quota = response.data.sessions_quota;
                    row.sessions_used = response.data.sessions_used;
                    this.$notifySuccess('Crédito liberado (+1)');
                })
                .catch((e) => {
                    this.$notifyError(e.response?.data?.message || e.response?.data || 'Erro ao liberar crédito');
                })
                .finally(() => {
                    this.actingId = null;
                });
        },
        blockScheduling(row) {
            this.actingId = row.id;
            http.post(`mentor/enrollments/${row.id}/block-scheduling`)
                .then((response) => {
                    row.scheduling_blocked_at = response.data.scheduling_blocked_at;
                    this.$notifySuccess('Agendamentos bloqueados');
                })
                .catch((e) => {
                    this.$notifyError(e.response?.data?.message || e.response?.data || 'Erro ao bloquear');
                })
                .finally(() => {
                    this.actingId = null;
                });
        },
        unblockScheduling(row) {
            this.actingId = row.id;
            http.post(`mentor/enrollments/${row.id}/unblock-scheduling`)
                .then((response) => {
                    row.scheduling_blocked_at = response.data.scheduling_blocked_at;
                    this.$notifySuccess('Agendamentos desbloqueados');
                })
                .catch((e) => {
                    this.$notifyError(e.response?.data?.message || e.response?.data || 'Erro ao desbloquear');
                })
                .finally(() => {
                    this.actingId = null;
                });
        },
        finishScheduling(row) {
            this.actingId = row.id;
            http.post(`mentor/enrollments/${row.id}/finish-scheduling`)
                .then((response) => {
                    row.scheduling_finished_at = response.data.scheduling_finished_at;
                    this.$notifySuccess('Agenda finalizada');
                })
                .catch((e) => {
                    this.$notifyError(e.response?.data?.message || e.response?.data || 'Erro ao finalizar');
                })
                .finally(() => {
                    this.actingId = null;
                });
        },
        getMentees(page) {
            if (page == this.menteePage || (this.menteePages && page > this.menteePages) || page == 0) {
                return;
            }
            startLoading('form', 'save');
            this.menteePage = page;
            this.$store.commit('api/setSpinner', true);
            http.get('menteeMentorings/?&page=' + this.menteePage + '&order_type=ASC&orderByAsc=&limit=4&with[]=mentee&mentoring_id=' + this.$route.params.id,
                    {
                        headers: {'Authorization': ` Bearer ${localStorage.getItem('token')} `}
                    })
                .then(response => {
                    this.menteeMentorings = response.data.data;
                    this.menteePages = response.data.pages;
                })
                .catch(error => {
                    console.error(error);
                })
                .finally(() => {
                    endLoading('form', 'save');
                    this.$store.commit('api/setSpinner', false);
                })
        },
    },
    mounted() {
        this.getMentees(1);
    }
}

</script>
